import { Box, IconButton, InputBase } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import { Search as SearchIcon } from "@material-ui/icons";
import clsx from "clsx";
import { ChangeEvent, Dispatch, RefObject } from "react";

import { Search, SearchType } from "@/utilities/types/search";

import { onKeyDownHandlerCreator } from "./SearchInput.Util";
import { searchInputStyles } from "./SearchInputStyles";


interface Props {
    search: Search;
    onSearchChange: (search: Search, updateMap?: boolean) => void;
    inputClasses?: string;
    setSearchOpen: (b: boolean) => void;
    inputRef: RefObject<HTMLInputElement>;
    setInputFocus: Dispatch<void>;
    handleMapUpdate: ()=> void;
}

const SearchInput = ({ search, onSearchChange, inputClasses, setSearchOpen, inputRef, setInputFocus , handleMapUpdate }: Props) => {
    const searchValue = search.searchQuery;

    const classes = searchInputStyles();

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onSearchChange({ ...search, searchQuery: e.currentTarget.value });
        setSearchOpen(true);
        setInputFocus();
    };

    const handleClearIndexSearch = () => {
        onSearchChange({ ...search, searchType: SearchType.Default }, true);
        setInputFocus();
    };

    const handleClearSelectedClient = () => {
        onSearchChange({ ...search, selectedClient: null }, true);
        setInputFocus();
    };
    const handleClearSelectedRegion = () => {
        onSearchChange({ ...search, selectedRegion: null }, true);
        setInputFocus();
    };

    const searchChip = () => {

        switch (search.searchType) {
            case SearchType.Clients:
                return <Chip className={classes.chip} label="Accounts" color="secondary" onDelete={handleClearIndexSearch} />;


            case SearchType.Regions:
                return <Chip className={classes.chip} label="Regions" color="secondary" onDelete={handleClearIndexSearch} />;

            default:
                if (search.selectedClient) {
                    return <Chip className={classes.chip} label={search.selectedClient.name} color="secondary" onDelete={handleClearSelectedClient} />;
                } else if (search.selectedRegion) {
                    return <Chip className={classes.chip} label={search.selectedRegion.name} color="secondary" onDelete={handleClearSelectedRegion} />;
                }

                return null;
        }


    };

    return (
        <Box className={classes.root}>
            <InputBase
                inputRef={inputRef}
                className={clsx(classes.input, inputClasses)}
                value={searchValue}
                onChange={handleSearchChange}
                placeholder="Search LiveUnits"
                inputProps={{ "aria-label": "Search", size: "1" }}
                startAdornment={searchChip()}
                endAdornment={
                    <IconButton
                        className={classes.iconButton}
                        aria-label="search"
                        onKeyDown={onKeyDownHandlerCreator(handleMapUpdate)}
                        // https://stackoverflow.com/a/9335401
                        // onBlur blocks onClick and gets triggered first. So decided to use onMouseDown. Which is equivalent to onClick
                        onMouseDown={handleMapUpdate}
                    >
                        <SearchIcon />
                    </IconButton>
                }
            />
        </Box>
    );
};

export default SearchInput;
